import {
  Component,
  Inject,
  Input,
  LOCALE_ID,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {MatDataSourceGeneric} from '@Services/base/daoService';
import {ActionDataTable, ColumnDataTable, DataTableComponent} from '@Common/widgets/general/data-table';
import {DatePipe} from '@angular/common';
import {FormModel, FormState} from '../../common/components/form/models';
import {FormulaireService} from '../../common/services/formulaire/formulaire.service';
import {MatDialog} from '@angular/material/dialog';
import {SubSink} from '@Common/core/utils/subsink';
import {GestionnairesFormulaireComponent} from './gestionnaires-formulaire/gestionnaires-formulaire.component';
import {FormStateOptionsModel} from '../../common/services/states/form-state-options.model';
import {SafeHtmlPipe} from '@Common/widgets/pipes';
import {DomSanitizer} from '@angular/platform-browser';
import {Individu, IndividuService, PubSubService} from '@Common/core/services';
import {roles} from '../../common/enum/roles';
import {StatesFormService} from '../../common/services/states/states-form.service';
import {concatMap, finalize, map, switchMap, tap} from 'rxjs/operators';
import {DialogData, DialogValidationComponent} from '@Common/widgets/general/dialog-validation';
import {SnackBarToastyService, typeToast} from '@Common/widgets/general/snack-bar';
import {FormModalComponent} from '../../common/components/form/form-builder/shared/form-modal/form-modal.component';
import {UrlService} from '../../common/services/url/url.service';
import {of} from "rxjs";
import {CategorieDemat} from "../../common/components/form/models/formdemat.model";
import {CategorieService} from "../../common/services/formulaire/categorie.service";
import {MatSelectChange} from "@angular/material/select";

@Component({
  selector: 'app-formulaires-liste',
  templateUrl: './formulaires-liste.component.html',
  styleUrls: ['./formulaires-liste.component.scss']
})
export class FormulairesListeComponent implements OnInit, OnDestroy, OnChanges {
  dsFormulaires: MatDataSourceGeneric<FormModel> = new MatDataSourceGeneric<FormModel>();
  extraParams: Map<string, string> = new Map<string, string>();
  @ViewChild(DataTableComponent) dataTable: DataTableComponent;
  hiddenFor = {
    Edit: 0,
    Delete: 1,
    NoResponses: 2,
    Link: 3,
    Archive: 4
  };

  columns: ColumnDataTable[] = [
    {
      columnDef: 'state',
      header: 'Statut',
      display: (row: FormModel) => this.displayStateForm(row),
      sort: true
    },

    {
      columnDef: 'nom', header: 'Formulaire', display: (row: FormModel) => row.nom,
      tooltip: (row: FormModel) => row.nom,
      sort: true, flex: 30
    },

    {
      columnDef: 'categories',
      header: 'Catégories',
      display: (row: FormModel) => this.displayCategories(row),
      sort: false
    },

    {
      columnDef: 'dt_created', header: 'Créé le', display: (element: FormModel) => {
        const dp: DatePipe = new DatePipe(this.locale);
        return `<strong>${dp.transform(`${element.dt_created}`, 'dd/MM/yyyy H:mm')}</strong>`;
      },
      tooltip: (element) => {
        return element.dt_created;
      },
      sort: true
    },

    {
      columnDef: 'dt_updated', header: 'Modifié le', display: (element: FormModel) => {
        const dp: DatePipe = new DatePipe(this.locale);
        return `<strong>${dp.transform(`${element.dt_updated}`, 'dd/MM/yyyy H:mm')}</strong>`;
      },
      tooltip: (element) => {
        return element.dt_updated;
      },
      sort: true
    },

  ];

  actions: ActionDataTable[] = [
    {
      label: 'edition', tooltip: 'Editer ce formulaire', icon: 'edit',
      tooltipfct: (row: FormModel) => this._toolEditTip(row),
      iconfct: (row: FormModel) => this._iconEdit(row),
      hidden: (row: FormModel) => this._hiddenFor(this.hiddenFor.Edit, row),
      click: (row: FormModel) => this.goToSelectedForm(row),
      iconcolorfct: (row: FormModel) => this._colorEdit(row)
    },
    { label: 'link_form', tooltip: 'Lien unique vers le formulaire à envoyer au(x) demandeur(s)', icon: 'link',
      click: (row) => this._openModalLinkForm(row),
      hidden: (row: FormModel) => this._hiddenFor(this.hiddenFor.Link, row) },
    {
      label: 'Duplication', tooltip: 'Dupliquer ce formulaire', icon: 'copy_all',
      click: (row: FormModel) => this._duplicate(row),
      iconcolor: 'accent',
    },

    {
      label: 'visualize', tooltip: 'Visualiser ce formulaire pour le tester', icon: 'remove_red_eye',
      click: (row: FormModel) => this.goToPublicViewSelectedForm(row),
      iconcolor: 'accent',
    },
    {
      label: 'avis_requesters', tooltip: 'Gérer vos listes de personnes pour les demandes d\'avis', icon: 'checklist',
      click: (row: FormModel) => this._requestersList(row),
      iconcolor: 'accent',
    },
    {
      label: 'gestionnaire', tooltip: 'Gérer les gestionnaires', icon: 'contacts',
      click: (row: FormModel) => this.formManagers(row),
      iconcolor: 'accent',
    },
    {
      label: 'delete', tooltip: 'Supprimer ce formulaire', icon: 'delete',
      hidden: (row: FormModel) => this._hiddenFor(this.hiddenFor.Delete, row),
      click: (row: FormModel) => this._deleteForm(row),
      iconcolor: 'warn',
    },
    {
      label: 'archive', tooltip: 'Archiver ce formulaire', icon: 'archive',
      hidden: (row: FormModel) => this._hiddenFor(this.hiddenFor.Archive, row),
      click: (row: FormModel) => this._archiveForm(row),
      iconcolor: 'warn',
    },

  ];

  subSink = new SubSink();

  @Input() adminView = false;
  connecte: Individu;
  categoriesList: CategorieDemat[] = [];
  itemCategories: number[] = [];

  constructor(@Inject(LOCALE_ID) private locale: string,
              private pubSubSvc: PubSubService,
              private dialog: MatDialog,
              private sanitized: DomSanitizer,
              private snakeSvc: SnackBarToastyService,
              private statsFormSvc: StatesFormService,
              private urlSvc: UrlService,
              private formulaireSvc: FormulaireService,
              private individuService: IndividuService,
              private categorieSvc: CategorieService,
              private router: Router, private route: ActivatedRoute,
              private toastySvc: SnackBarToastyService) {
    this.dsFormulaires.daoService = this.formulaireSvc;
  }

  ngOnInit(): void {
    this.subSink.sink = this.individuService.individu$.subscribe(individu => {
      this.connecte = individu;
      const isAdmin = this.individuService.hasRole(individu, roles.admin);
      if (!isAdmin || !this.adminView) {
        this.extraParams.set('by_gestionnaire', individu.uid);
      }
      this.extraParams.set('exclude_state', FormState.archived.toString());
    });
    this.subSink.sink = this.categorieSvc.listAllItems()
      .subscribe(result => {
        this.categoriesList = result.list?.filter(cat => cat.active);
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    const cur = changes.adminView.currentValue;
    const old = changes.adminView.previousValue;
    if (cur !== old && !changes.adminView.firstChange) {
      if (cur) {
        this.extraParams.delete('by_gestionnaire');
      } else {
        this.extraParams.set('by_gestionnaire', this.connecte.uid);
      }
      this.dataTable?.reload();
    }
  }

  displayCategories(row: FormModel): string {
    if (!row.categories_obj || row.categories_obj.length === 0) {
      return '';
    }
    return row.categories_obj.map(cat => cat.name).join(', ');
  }

  private _openModalLinkForm(form: FormModel) {
    this.formulaireSvc.openModaleUrlForm(form);
  }
  private _isDraft(row: FormModel) {
    return row.state === FormState.draft;
  }
  private _toolEditTip(row: FormModel) {
    if (this._isDraft(row)) {
      return 'Editer le formulaire avec ses champs';
    }
    return 'Editer le titre, description, signature du formulaire';
  }
  private _iconEdit(row: FormModel) {
    if (this._isDraft(row)) {
      return 'edit';
    }
    return 'border_color';
  }
  private _colorEdit(row: FormModel) {
    if (this._isDraft(row)) {
      return 'primary';
    }
    return 'accent';
  }
  private _hiddenFor(hiddenFor: number, row: FormModel): boolean {
    switch (hiddenFor) {
      case this.hiddenFor.Edit:
        return false;
      case this.hiddenFor.Delete:
        return row.responses_total > 0 || row.state === FormState.published;
      case this.hiddenFor.NoResponses:
        return row.responses_send === 0;
      case this.hiddenFor.Link:
        return row.state !== FormState.published || ! row?.url_obj[0];
      case this.hiddenFor.Archive:
        return row.state === FormState.draft;
      default:
        return true;
    }
  }
  displayStateForm(formulaire: FormModel) {
    if (formulaire.state) {
      const sp: SafeHtmlPipe = new SafeHtmlPipe(this.sanitized);
      const state: FormStateOptionsModel = this.statsFormSvc.getStateModel(formulaire.state);
      const display = `<span style="border-radius: 10px; background-color: ${state.color}; padding: 5px; color: white;">${state.label.toLowerCase()}</span>`;
      return sp.transform(display);
    }
    return '';
  }
  ngOnDestroy() {
    this.subSink.unsubscribe();
  }
  private _openFormDialog(item): void {
    const data = {...item};
    const dialogRef = this.dialog.open(FormModalComponent, {
      disableClose: true,
      width: '800px',
      data: {
        form: data,
        titleModale: 'Le formulaire a été publié, seules les informations ci-après sont modifiables',
        buttonText: {
          ok: 'Enregistrer',
          cancel: 'Abandonner'
        },
      },
    });
    dialogRef.updatePosition({top: '100px'});
    dialogRef.afterClosed().subscribe(_result => {
      if (_result) {
        this.pubSubSvc.publish('loading', true);
        const form = _result as FormModel;
        form.signature_email = form.signature_email || 'Université Paris 8';

        const formObservable = (form.attachments && form.attachments.length > 0)
          ? this.formulaireSvc.uploadFiles(form.attachments, form.id).pipe(map(() => form))
          : of(form);

        this.subSink.sink = formObservable
          .pipe(
            switchMap((_form) => this.formulaireSvc.patch(_form, 'uuid')),
            tap(_form => {
              this.snakeSvc.toasty('Formulaire', `Le formulaire "${_form.nom}" a bien été mis à jour`, typeToast.success);
              this.dataTable.reload();
            }),
            finalize(() => this.pubSubSvc.publish('loading', false))
          )
          .subscribe();
      }

    });
  }
  goToSelectedForm(formulaire: FormModel): void {
    if (this._isDraft(formulaire)) {
      this.router.navigate(['edit', formulaire.uuid], {relativeTo: this.route.parent});
    } else {
      this._openFormDialog(formulaire);
    }
  }

  goToPublicViewSelectedForm(formulaire: FormModel): void {
    this.router.navigate(['procedure', formulaire.uuid], {relativeTo: this.route.parent});
  }
  private formManagers(row: FormModel) {
    const modalConfirm = this.dialog.open(GestionnairesFormulaireComponent, { data: row, disableClose: true});
    modalConfirm.updatePosition({top: '40px'});
    this.subSink.sink = modalConfirm.afterClosed().subscribe(() => {
      this.dataTable.reload();
    });
  }

  private _duplicate(form: FormModel) {
    const data = new DialogData();
    data.title = 'Duplication du formulaire';
    data.subtitle = `Formulaire source pour la copie : ${form.nom}`;
    data.message = 'Afin de confirmer, veuillez saisir un nouveau titre au formulaire<br/>';
    data.buttonTextTrue = 'Valider';
    data.buttonTextFalse = 'Abandonner';
    data.content = true;
    data.contentData = form.nom;
    data.contentElement = 'input';
    data.contentMinLength = 1;
    data.contentMaxLength = 80;
    data.contentPlaceHolder = `Nouveau titre du formulaire (max ${data.contentMaxLength} cars.)`;

    const modalConfirm = this.dialog.open(DialogValidationComponent, {data: data});
    modalConfirm.updatePosition({top: '40px'});
    this.subSink.sink = modalConfirm.afterClosed().subscribe(_data => {
      if (_data && _data.confirm) {
        this.pubSubSvc.publish('loading', true);
        this.subSink.sink = this.formulaireSvc.duplicate(form.uuid, _data.contentData)
          .pipe(finalize(() => this.pubSubSvc.publish('loading', false)))
          .subscribe(
            () => {
              this.dataTable.reload();
            });
      }
    });
  }
  private _archiveForm(row: FormModel): void {
    const data = new DialogData();
    data.title = 'Archivage d\'un formulaire';
    data.message = `<strong>Souhaitez-vous archiver le formulaire "${row.nom}" ?</strong>
                    <br/><br/>
                    <ul>
                      <li><strong>> Plus aucune demande ne pourra s'effectuer dessus.</strong></span></li>
                      <li><strong>> Les demandes courantes ne pourront plus être instruites.</strong></li>
                      <li><strong>> Le lien lié à ce formulaire sera supprimé</strong></li>
                    </ul>
                    <br/>Vous pourrez le retrouver dans l'onglet "Formulaires archivés"`;
    data.iconType = 'warning';

    const dialogRef = this.dialog.open(DialogValidationComponent, {
      data: data
    });

    dialogRef.updatePosition({ top: '40px' });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.pubSubSvc.publish('loading', true);
        row.state = FormState.archived;
        this.subSink.sink = this.formulaireSvc
          .patch(row, 'uuid')
          .pipe(concatMap(_ => this.urlSvc.deleteUrlByForm(row.id)),
                finalize(() => this.pubSubSvc.publish('loading', false)))
          .subscribe(_ => {
            this.toastySvc.toasty('Formulaire',
                             `Le formulaire "${row.nom}" a bien été archivé, retrouvez le dans l'onglet "formulaire archivés"`,
                                  typeToast.success);
            this.dataTable.reload();
          });
      }
    });
  }
  private _deleteForm(row: FormModel): void {
    const data = new DialogData();
    data.title = 'Suppression d\'un formulaire';
    data.message = `Souhaitez-vous supprimer le formulaire "${row.nom}" ?`;
    data.iconType = 'warning';

    const dialogRef = this.dialog.open(DialogValidationComponent, {
      data: data
    });

    dialogRef.updatePosition({ top: '40px' });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.pubSubSvc.publish('loading', true);
        this.subSink.sink = this.formulaireSvc.deleteById(row.uuid).subscribe(_ => {
          this.toastySvc.toasty('Formulaire', `Le formulaire "${row.nom}" a bien été supprimé`, typeToast.success);
          this.pubSubSvc.publish('loading', false);
          this.dataTable.reload();
        });
      }
    });
  }
  private _requestersList(formulaire: FormModel) {
    this.router.navigate(['requesters-list', formulaire.uuid], {relativeTo: this.route.parent});
  }

  protected onSelectState($event: MatSelectChange) {
    const selected = $event.value as number[];
    if (selected.length) {
      this.extraParams.set('categories', selected.join(','));
    } else {
      this.extraParams.delete('categories');
    }
    this.dataTable.reload();
  }

}
